import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Features } from './pages/Features';
import { Infrastructure } from './pages/Infrastructure';
import { Policy } from './pages/Policy';
import { Partners } from './pages/Partners';
import { Pricing } from './pages/Pricing';
import { Contact } from './pages/Contact';
import { Blog } from './pages/Blog';
import { BlogDetail } from './pages/BlogDetail';
import { AdminLogin } from './pages/Admin/AdminLogin';
import { AdminDashboard } from './pages/Admin/AdminDashboard';
import { BlogEditor } from './pages/Admin/BlogEditor';
import { PrivacyPolicy } from './pages/privacypolicy';
import { TermsOfService } from './pages/termsofservice';
import { FAQ } from './pages/faq';



function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={
              <>
                <Header />
                <Home />
                <Footer />
              </>
            } />
            <Route path="/about" element={
              <>
                <Header />
                <About />
                <Footer />
              </>
            } />
            <Route path="/features" element={
              <>
                <Header />
                <Features />
                <Footer />
              </>
            } />
            <Route path="/infrastructure" element={
              <>
                <Header />
                <Infrastructure />
                <Footer />
              </>
            } />
            <Route path="/policy" element={
              <>
                <Header />
                <Policy />
                <Footer />
              </>
            } />
            <Route path="/partners" element={
              <>
                <Header />
                <Partners />
                <Footer />
              </>
            } />
            <Route path="/pricing" element={
              <>
                <Header />
                <Pricing />
                <Footer />
              </>
            } />
            <Route path="/contact" element={
              <>
                <Header />
                <Contact />
                <Footer />
              </>
            } />
            <Route path="/privacy-policy" element={
              <>
                <Header />
                <PrivacyPolicy />
                <Footer />
              </>
            } />

            <Route path="/terms-of-service" element={
              <>
                <Header />
                <TermsOfService />
                <Footer />
              </>
            } />

            <Route path="/faq" element={
              <>
                <Header />
                <FAQ />
                <Footer />
              </>
            } />

            <Route path="/blog" element={
              <>
                <Header />
                <Blog />
                <Footer />
              </>
            } />
            <Route path="/blog/:id" element={
              <>
                <Header />
                <BlogDetail />
                <Footer />
              </>
            } />

            {/* Admin Routes (No Header/Footer) */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/blog/new" element={<BlogEditor />} />
            <Route path="/admin/blog/edit/:id" element={<BlogEditor />} />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;
